// ServiciosFeatures.jsx
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import styles from './ServiciosFeatures.module.scss';
import data from '../../data/serviciosFeaturesData.json';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

const hoverEffect = {
  scale: 1.025,
  boxShadow: '0px 15px 30px rgba(0, 0, 0, 0.2)',
};

const ServiciosFeatures = () => {
  const [index, setIndex] = useState(0);
  const total = data.length;
  const feature = data[index];

  const prev = () => {
    if (index > 0) setIndex(index - 1);
  };

  const next = () => {
    if (index < total - 1) setIndex(index + 1);
  };

  const imageSrc = require(`../../assets/images/ServiciosFeatures/${feature.image}`);

  return (
    <div className={styles.container}>
      <div className={styles.imageSection}>
        <motion.img
          src={imageSrc}
          alt={feature.title}
          className={styles.image}
          whileHover={hoverEffect}
          transition={{ type: 'spring', stiffness: 300, damping: 20 }}
        />
      </div>
      <div className={styles.textSection}>
        <h3 className={styles.title}>{feature.title}</h3>
        <p className={styles.subtitle}>{feature.subtitle}</p>
        <div className={styles.controls}>
          <button
            onClick={prev}
            disabled={index === 0}
            className={styles.controlButton}
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>
          <button
            onClick={next}
            disabled={index === total - 1}
            className={styles.controlButton}
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServiciosFeatures;
